module.exports = __webpack_public_path__ + "img/WE_blog3.aa8040cf.png";